import { getIosChannelConfig } from '@/api/iosChannel';
import { IOS_DOWNLOAD_URL } from '../config/downloadUrls';
import { DownloadUrls } from '../config/types';

export interface IosChannelState {
  iosDownloadUrl: string;
  iosAppKey: string;
}

/** 从 URL 查询串取指定参数 */
export const getQueryParam = (url: string, name: string): string => {
  if (!url) {
    return '';
  }
  try {
    return new URL(url).searchParams.get(name) || '';
  } catch {
    const match = url.match(new RegExp('[?&]' + name + '=([^&#]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }
};

/** 将当前页地址栏参数合并到目标 URL（目标已有同名参数时保留目标值） */
export const mergeUrlWithPageQuery = (url: string): string => {
  const pageSearch = window.location.search;
  if (!url || !pageSearch || pageSearch === '?') {
    return url;
  }
  try {
    const target = new URL(url);
    new URLSearchParams(pageSearch).forEach((value, key) => {
      if (!target.searchParams.has(key)) {
        target.searchParams.append(key, value);
      }
    });
    return target.toString();
  } catch {
    const joiner = url.indexOf('?') >= 0 ? '&' : '?';
    return `${url}${joiner}${pageSearch.slice(1)}`;
  }
};

export const invokeOpenInstall = (
  appKey: string,
  onReady: (instance: any, data: any) => void,
) => {
  /* tslint:disable */
  const data = OpenInstall.parseUrlParams();
  new OpenInstall({
    appKey,
    onready() {
      onReady(this, data);
    },
  }, data);
  /* tslint:enable */
};

/** 拉取 iOS 渠道配置；若需跳转则返回 redirected: true */
export const fetchIosChannelConfig = async (): Promise<IosChannelState & { redirected?: boolean }> => {
  const empty: IosChannelState = { iosDownloadUrl: '', iosAppKey: '' };
  try {
    const { data: { data } } = await getIosChannelConfig();
    const downUrl = (data && data.downUrl) ? data.downUrl : '';
    if (
      downUrl
      && downUrl.indexOf('apple.com') < 0
      && window.location.href.indexOf('toIosChannel') < 0
    ) {
      window.location.href = mergeUrlWithPageQuery(downUrl);
      return { ...empty, redirected: true };
    }
    return {
      iosDownloadUrl: downUrl,
      iosAppKey: getQueryParam(downUrl, 'key')
        || ((data && data.shareKey) ? data.shareKey : ''),
    };
  } catch {
    return empty;
  }
};

/** iOS：有 OpenInstall key 则拉端，否则打开跳转链接 */
export const downloadIosApp = (state: IosChannelState) => {
  if (state.iosAppKey && window.location.href.indexOf('toIosChannel') >= 0) {
    invokeOpenInstall(state.iosAppKey, (instance, data) => {
      setTimeout(() => {
        instance.wakeupOrInstall({ data });
      });
    });
    return;
  }
  window.open(mergeUrlWithPageQuery(state.iosDownloadUrl || IOS_DOWNLOAD_URL));
};

/** Android：OpenInstall 唤起 + 打开 apk */
export const downloadAndroidApp = (downloadUrls: DownloadUrls) => {
  const androidUrl = downloadUrls.ANDROID[process.env.NODE_ENV];
  if (!androidUrl) {
    return;
  }
  invokeOpenInstall('faiw5d', (instance) => {
    instance.schemeWakeup();
    window.open(androidUrl);
  });
};
